// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__lFJ94","title":"Images90_title__1SwIK","images":"Images90_images__18tzD"};